import { Cable, createCable } from "@anycable/web";
import * as Sentry from "@sentry/react";
import { createContext, useEffect, useState } from "react";
import { baseUrlAltSubdomain } from "../components/Helper/Url";
import { CommandMessage } from "./CommandTypes";

export type JobsiteCommandContextType = {
    error: any;
    setError: (error: any) => void;
    cableApp: Cable | null;
    setCableApp: (cable: Cable | null) => void;
    zoom: number | null;
    setZoom: (zoom: number | null) => void;
    runInterval: boolean;
    setRunInterval: (run: boolean) => void;
    intervalUpdate: boolean;
    setIntervalUpdate: (update: boolean) => void;

    messages: CommandMessage[];
    setMessages: (messages: CommandMessage[]) => void;
    devicePixelRatio: number;
    setDevicePixelRatio: (ratio: number) => void;
    lastUpdated: Date | null;
    setLastUpdated: (date: Date | null) => void;
};

export const JobsiteCommandContext = createContext<JobsiteCommandContextType | null>(null);
function JobsiteCommandContextProvider({ children }: { children: React.ReactNode }) {
    const [error, setError] = useState<any>(null);
    const [cableApp, setCableApp] = useState<Cable | null>(null);
    const [zoom, setZoom] = useState<number | null>(null);
    const [intervalUpdate, setIntervalUpdate] = useState(false);
    const [runInterval, setRunInterval] = useState(true);
    const [messages, setMessages] = useState<CommandMessage[]>([]);
    const [devicePixelRatio, setDevicePixelRatio] = useState<number>(window.devicePixelRatio);
    const [lastUpdated, setLastUpdated] = useState<Date | null>(null);

    useEffect(() => {
        const handleResize = () => {
            setDevicePixelRatio(window.devicePixelRatio);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            if (runInterval) {
                setIntervalUpdate((prev) => !prev);
            }
        }, 60000); // Update every 60 seconds

        return () => clearInterval(interval);
    }, [runInterval]);

    useEffect(() => {
        setDevicePixelRatio(window.devicePixelRatio);
    }, []);

    useEffect(() => {
        const appUrl = baseUrlAltSubdomain("app") + "/cable";
        const cableUrl = appUrl.replace("https://", "wss://").replace("http://", "ws://");

        setCableApp(createCable(cableUrl));

        return () => {
            try {
                cableApp?.disconnect();
            } catch (error) {
                Sentry.captureException(error);
            }
        };
    }, []);

    useEffect(() => {}, []);
    return (
        <JobsiteCommandContext.Provider
            value={{
                error,
                setError,
                cableApp,
                setCableApp,
                zoom,
                setZoom,
                runInterval,
                setRunInterval,
                intervalUpdate,
                setIntervalUpdate,
                messages,
                setMessages,
                devicePixelRatio,
                setDevicePixelRatio,
                lastUpdated,
                setLastUpdated,
            }}
        >
            {children}
        </JobsiteCommandContext.Provider>
    );
}
export default JobsiteCommandContextProvider;
